<template>
  <div class="products-list">
    <ProductsListItem
        v-for="product in visibleProducts"
        :product="product"
        :key="product.CODARTICULO"
        @ProductSelected="onProductSelected"
    />
  </div>
</template>
<script>
import ProductsListItem from './ProductsListItem'

export default {
  components: { ProductsListItem },
  props: {
    products: { type: Array }
  },
  computed: {
    visibleProducts() {
      return this.products.filter(product => !product.OCULTO)
    }
  },
  methods: {
    onProductSelected(product) {
      this.$emit('ProductSelected', product)
    }
  }
}
</script>
<style lang="scss">
.products-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 0.4rem;
  grid-auto-rows: minmax(6.8rem, 1fr);

  @media screen and (max-width: 340px) {
    grid-template-columns: repeat(2, 1fr);
  }

  &__item {
    align-items: flex-end;
    background-color: white;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    user-select: none !important;
    padding: 0.4rem;
    text-align: center;
    position: relative;
    line-height: 0.8rem;

    &__description {
      border-radius: 0 0 0.4rem 0.4rem;
      font-size: 0.8rem;
      font-weight: bold;
      text-transform: uppercase;
    }

    &__price {
      position: absolute;
      top: 0.25rem;
      right: 0.25rem;
      font-weight: normal;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Products/ProductsList.vue